import { createAction, props } from '@ngrx/store';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { ReportCardLayout } from 'src/app/modules/customer-shared/models/ReportCardLayout';

const TAG = `[Audits]`;

export const loadReports = createAction(`${TAG} Load Latest Reports`, props<{ locationId: number }>());
export const loadReportsSuccess = createAction(
  `${TAG} Load Latest Reports Success`,
  props<{ latestReports: IGlimpseReport[]; locationId: number }>(),
);

export const changeLayout = createAction(`${TAG} Change Report Card Layout`, props<{ layout: ReportCardLayout }>());
